import { DailyReportsTemplate } from "app/features/reporting/templates/DailyReportsTemplate";

export function DailyReportingScreen() {
  return <DailyReportsTemplate />;
}
